import React, { useState } from 'react'
import SelectAsync from 'react-select/async'

import { Location } from '@services/api/locations'

import { styles } from '../utils/select'
import { FranchiseDto } from '@services/api/franchise/types'
import { FranchiseApi } from '@services/api/franchise'

interface SelectFranchiseProps {
  value?: FranchiseDto
  location?: Location
  onChange?: (franchise: FranchiseDto) => void
}

export const SelectFranchise = ({
  value: franchise,
  onChange
}: SelectFranchiseProps) => {
  const [loading, setLoading] = useState(false)

  const value = franchise
    ? { value: franchise, label: `${franchise.titlePage}` }
    : undefined

  const search = async (value: string) => {
    setLoading(true)
    try {
      const {
        data: { content }
      } = await FranchiseApi.index({
        search: {
          title_page: value
        },
        per: 10
      })

      return content.map(_franchise => ({
        value: _franchise,
        label: _franchise.titlePage
      }))
    } catch (error) {
      console.error(error)
      return []
    } finally {
      setLoading(false)
    }
  }

  return (
    <SelectAsync
      instanceId="company"
      placeholder="Nome da empresa"
      className="react-select-container"
      classNamePrefix="react-select"
      noOptionsMessage={() => 'Digite aqui'}
      styles={styles<FranchiseDto>()}
      isClearable
      isSearchable
      loadOptions={value => search(value)}
      isLoading={loading}
      value={value}
      onChange={option => onChange && onChange(option?.value)}
    />
  )
}
